// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/settings/Menu0/Item.css
// module id = 2026
// module chunks = 0